// extracted by mini-css-extract-plugin
module.exports = {"fa-spin":"index_fa-spin__1rZvC","faSpin":"index_fa-spin__1rZvC"};